<template>
  <div>
    <reference-file-download-dialog
      :value="value"
      :review="review"
      :relevant-count="relevantCount"
      :not-relevant-count="notRelevantCount"
      :not-sure-count="notSureCount"
      :unscreened-count="unscreenedCount"
      @download="downloadReferences"
      @input="onCloseDialog"
    />
  </div>
</template>

<script>
import ReferenceFileDownloadDialog from './ReferenceFileDownloadDialog';
import { Review } from '@/models';
import { mapActions } from 'vuex';

export default {
  name: 'DownloadReferencesController',
  components: { ReferenceFileDownloadDialog },
  props: {
    value: {
      type: Boolean,
      required: true,
    },
    review: {
      type: Review,
      default: () => null,
    },
  },
  computed: {
    relevantCount() {
      const { relevantCount } = this.review.screeningOutcomeSummary;
      return relevantCount || 0;
    },
    notRelevantCount() {
      const {
        notRelevantCount,
      } = this.review.screeningOutcomeSummary;
      return notRelevantCount || 0;
    },
    notSureCount() {
      const { notSureCount } = this.review.screeningOutcomeSummary;
      return notSureCount || 0;
    },
    unscreenedCount() {
      const {
        unscreenedCount,
      } = this.review.screeningProgressSummary;
      return unscreenedCount || 0;
    },
  },
  methods: {
    ...mapActions({
      exportReferences: 'reference/export',
    }),
    async downloadReferences(outcomes) {
      const reviewId = this.review.id;
      const exportDto = await this.exportReferences({
        reviewId,
        outcomes,
      });
      window.location.href = exportDto.signedDownloadUrl;
      this.onCloseDialog();
    },
    onCloseDialog() {
      this.$emit('input', false);
    },
  },
};
</script>
